export const DATABASE_INITIALIZATION_STORE_KEY = 'initialization';
